import { Env } from '@/libs/env/env';

export const APP_VERSION = Env.NEXT_PUBLIC_APP_VERSION;
